<template>
  <div class="form-group-checkbox">
    <label class="checkbox-label" v-if="label">
      <input
        name="check_legal"
        type="checkbox"
        :checked="modelValue"
        @change="changeCheck"
        :openInfo="modelOpen"
        class="field"
      />
      <span @click.prevent="changeCheck">{{ label }}</span>
    </label>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    modelOpen: {
      type: Boolean,
      required: true
    }
  },
  // emits: ['updateModelOpen', 'update:modelValue'],
  methods: {
    ...mapMutations(['setLegal']),
    changeCheck () {
      this.setLegal(!this.modelValue)
      if (!this.modelOpen && !this.modelValue) {
        this.$emit('updateModelOpen', !this.modelOpen)
      }
    }
  }
}
</script>

<style>
.form-group-checkbox {
  line-height: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.form-group-checkbox label {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.form-group-checkbox label input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(225, 225, 225, var(--tw-border-opacity));
  border-radius: 0.5rem;
  border-width: 1px;
  cursor: pointer;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  -webkit-flex-grow: 0;
  flex-grow: 0;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  height: 1.5rem;
  margin-right: 0.5rem;
  width: 1.5rem;
}
.form-group-checkbox label input:checked {
  background-color: var(--primary);
  border-style: none;
  background-image: url('/landing_co/input-check.svg');
}
.form-group-checkbox label input:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.form-group-checkbox label span:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.form-group-checkbox a {
  cursor: pointer;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}
.checkbox-label:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
</style>
